import Vue from 'vue'
import Router, { NavigationGuardNext, Route } from 'vue-router'
import fb from './firebase'
import firebase from 'firebase/app'

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

// mobile-not-supported is still here to be backward compatible with 3.7.0, can go once 3.7.0 is depricated

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventList", webpackPrefetch: true */ './views/EventList')
  },
  {
    path: '/debug/:castId',
    name: 'debug',
    props: true,
    component: () => import(/* webpackChunkName: "public" */ './views/Debug')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ './modules/user/views/Login')
  },
  {
    path: '/register/:inviteId?',
    name: 'register',
    props: true,
    component: () => import(/* webpackChunkName: "register" */ './modules/user/views/Register')
  },
  {
    path: '/invite/:inviteId',
    redirect: '/register/:inviteId'
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import(/* webpackChunkName: "forgotPassword" */ './modules/user/views/ForgotPassword')
  },
  {
    path: '/auth/action',
    name: 'auth',
    component: () => import(/* webpackChunkName: "resetPassword" */ './modules/user/views/ResetPassword')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import(/* webpackChunkName: "logout" */ './views/Logout')
  },
  {
    path: '/link/:pointerId',
    name: 'link',
    props: true,
    component: () => import(/* webpackChunkName: "redirectLink" */ './modules/user/views/RedirectGuestLink')
  },
  {
    path: '/end-session',
    name: 'end-session',
    component: () => import(/* webpackChunkName: "EndSession" */ './modules/user/views/EndSession')
  },
  {
    path: '/team/:subView',
    name: 'team',
    meta: { requiresAuth: true },
    props: true,
    component: () => import(/* webpackChunkName: "memberManager" */ './views/MemberManagement')
  },
  {
    path: '/teamsettings/:subView',
    name: 'teamsettings',
    meta: { requiresAuth: true },
    props: true,
    component: () => import(/* webpackChunkName: "memberManager" */ './views/TeamManagement')
  },
  {
    path: '/cefapplianceManager',
    name: 'cefApplianceManager',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "CefApplicanceManager" */ './modules/cefappliance/views/CefApplianceManager')
  },
  {
    path: '/cefappliance/:applianceId',
    name: 'cefAppliance',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "CefApplicanceManager" */ './components/CefAppliance')
  },
  {
    path: '/rapidswitcher/:applianceId',
    name: 'rapidStreamSwitcher',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "CefApplicanceManager" */ './modules/rapidstreamswitcher/views/RapidStreamSwitcher')
  },
  {
    path: '/rapidswitcher/:applianceId/output',
    name: 'rapidStreamSwitcherOutput',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "CefApplicanceManager" */ './modules/rapidstreamswitcher/views/Output')
  },
  {
    path: '/manage-teams/:subView',
    name: 'teams',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "teamManager" */ './views/TeamsManager')
  },
  {
    path: '/addfacebook',
    name: 'addFacebook',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "sceneManager" */ './views/AddFacebook')
  },
  {
    path: '/streams',
    redirect: { name: 'streams', params: { subView: 'input' } }
  },
  {
    path: '/streams/:subView',
    name: 'streams',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "streamManager" */ './views/StreamsManager')
  },
  {
    path: '/events',
    redirect: { name: 'events', params: { subView: 'active' } }
  },
  {
    path: '/events/:subView',
    name: 'events',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventList" */ './views/EventList')
  },
  {
    path: '/clipper',
    name: 'clipper',
    props: { subView: 'clipper' },
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "streamManager" */ './views/EventList')
  },
  {
    path: '/mobile-not-supported',
    name: 'mobileNotSupported',
    component: () => import(/* webpackChunkName: "notAllowedMobile" */ './views/EventList')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "contactInfo" */ './views/ContactInfo')
  },
  {
    path: '/layout',
    name: 'layout',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "layoutManager" */ './views/LayoutManager')
  },
  {
    path: '/layouteditor/:id',
    name: 'layouteditor',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "layoutEditor" */ './modules/layouts/views/SelectLayoutEditor')
  },
  {
    path: '/widget/chat/:id',
    name: 'chatwidget',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "chatWidget" */ './views/ChatWidget')
  },
  {
    path: '/moderation',
    name: 'moderation',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "ingest" */ './modules/moderation/views/Moderation')
  },
  {
    path: '/ops',
    name: 'ops',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitor" */ './views/OpsMonitor')
  },
  {
    path: '/ops/pending',
    name: 'opsRequest',
    props: { subView: 'pending' },
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitor" */ './views/OpsMonitor')
  },
  {
    path: '/ops/warnings',
    name: 'opsWarnings',
    props: { subView: 'warnings' },
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitor" */ './views/OpsMonitor')
  },
  {
    path: '/ops/social',
    name: 'opsSettings',
    props: { subView: 'social' },
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitor" */ './views/OpsMonitor')
  },
  {
    path: '/ops/startstopmanager',
    name: 'opsstartstopmanager',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsStartStopManager" */ './modules/startstopmanager/views/StartStopManager')
  },
  {
    path: '/ops/wrtcservers',
    name: 'opswrtcservers',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsWRTCServers" */ './modules/transcodingregions/views/WRTCOverview')
  },
  {
    path: '/ops/transcoding',
    name: 'opstranscoding',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitorTranscoding" */ './views/OpsMonitorTranscoding')
  },
  {
    path: '/ops/archiver',
    name: 'opsarchiver',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitorArchiver" */ './modules/archiver/views/OpsArchiver')
  },
  {
    path: '/ops/backendservices',
    name: 'ops_backendservices',
    meta: { requiresAuth: true},
    component: () => import(/* webpackChunkName: "backendServices" */ './modules/releases/views/OpsMonitorBackendServices')
  },
  {
    path: '/ops/srt',
    name: 'opsSrt',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opssrt" */ './views/SRTMonitor')
  },
  {
    path: '/ops/stats',
    name: 'ops_stats',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "ops_stats" */ './modules/statistics/views/OpsStats')
  },
  {
    path: '/ops/details/:id',
    name: 'opsdetails',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitorDetails" */ './views/OpsMonitorDetails')
  },
  {
    path: '/ops/roomsprocessing',
    name: 'opsRoomsProcessing',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "rooms" */ './modules/rooms/views/RoomsProcessing')
  },
  {
    path: '/assets/:selectedFolderId?',
    name: 'assets',
    meta: { requiresAuth: true },
    props: true,
    component: () => import(/* webpackChunkName: "assetManager" */ './views/AssetManagement')
  },
  {
    path: '/event/new/:editMode/:castType',
    name: 'createEvent',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventWizard" */ '@/modules/events/views/EventWizard')
  },
  {
    path: '/event/copy/:editMode/:castId',
    name: 'copyEvent',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventWizard" */ '@/modules/events/views/EventWizard')
  },
  {
    path: '/event/edit/:editMode/:castId',
    name: 'editEvent',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventWizard" */ '@/modules/events/views/EventWizard')
  },
  {
    path: '/event/:id',
    name: 'liveEvent',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "liveEvent", webpackPrefetch: true */ './views/LiveEvent')
  },
  {
    path: '/event/panel/:id/:mode',
    name: 'liveEventBreakout',
    meta: { requiresAuth: true },
    props: true,
    component: () => import(/* webpackChunkName: "liveEventBreakout" */ './views/LiveEventBreakout')
  },
  {
    path: '/template/:templateId/cast/:castId',
    name: 'castTemplate',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "castTemplate" */ '@/modules/templates/views/CastTemplate')
  },
  {
    path: '/station/:stationId',
    name: 'station',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "liveEvent" */ './views/LiveEvent')
  },
  {
    path: '/cefappliancegraphics/:cefApplianceId/:type',
    name: 'cefApplianceGraphics',
    props: true,
    component: () => import(/* webpackChunkName: "cefApplianceBackground" */ './modules/cefappliance/views/CefApplianceGraphics')
  },
  {
    path: '/preview/:castId',
    name: 'preview',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "preview" */ './views/Preview')
  },
  {
    path: '/cast_templates',
    name: 'castTemplates',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "castTemplates" */ './views/CastTemplates')
  },
  {
    path: '/selftest',
    name: 'selftest',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "selftest" */ './components/SelfTestMobile')
  },
  {
    path: '/cef/:id',
    name: 'cefEvent',
    component: () => import(/* webpackChunkName: "cefEvent" */ './views/CefEvent'),
    beforeEnter: (_to: Route, _from: Route, next: NavigationGuardNext<Vue>) => next() // login via token
  },
  {
    path: '/ios-front/:id',
    name: 'iosFront',
    component: () => import(/* webpackChunkName: "cefEvent" */ './views/CefEvent'),
    // beforeEnter: (_to, _from, next) => next() // login via token
  },
  {
    path: '/ios-back/:id',
    name: 'iosBack',
    component: () => import(/* webpackChunkName: "cefEvent" */ './views/CefEvent'),
    // beforeEnter: (_to, _from, next) => next() // login via token
  },
  {
    path: '/ios/:id',
    name: 'iosWrapper',
    component: () => import(/* webpackChunkName: "IosWrapper" */ './views/IosWrapper'),
    // beforeEnter: (_to, _from, next) => next() // login via token
  },
  {
    path: '/reports',
    name: 'reports',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "billing" */ './views/Billing')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "dashboard" */ './modules/dashboard/views/Dashboard')
  },
  {
    path: '/rooms',
    name: 'rooms',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "rooms" */ './modules/rooms/views/RoomsOverview')
  },
  {
    path: '/stations',
    name: 'stations',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "rooms" */ './modules/station/views/StationsOverview')
  },
  {
    path: '/roomredirect',
    name: 'defaultRedirectRooms',
    component: () => import(/* webpackChunkName: "redirectLink" */ './views/RedirectRooms')
  },
  {
    path: '/athletemoments',
    name: 'defaultRedirectAthleteMoments',
    component: () => import(/* webpackChunkName: "redirectLink" */ './views/RedirectAthleteMoments')
  },
  {
    path: '/docs',
    beforeEnter: () => window.location.href = 'https://kiswestudio.zendesk.com/'
  },
  {
    path: '/flags',
    name: 'featureflags',
    component: () => import(/* webpackChunkName: "featureFlags" */ './views/FeatureFlags')
  },
  {
    path: '/ingest/:castId',
    name: 'ingest',
    props: true,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "ingest" */ './modules/screenshare/views/HighQualityInput')
  },
  {
    path: '/styleguide',
    name: 'styleguide',
    component: () => import(/* webpackChunkName: "styleGuidePage" */ './modules/kisweui/views/StyleGuidePage')
  },
  {
    path: '/styleguide/input',
    name: 'kisweInput',
    component: () => import(/* webpackChunkName: "kisweInputPage" */ './modules/kisweui/views/KisweInputPage')
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "notFound" */ './views/NotFound')
  },
  {
    path: '*',
    redirect: '/404'
  }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL ?? '',
  routes
})

let authStateChangeUnsubscriber: firebase.Unsubscribe|null = null
/*
  Make sure that the 'next' function is called exactly once in any given pass through
  the navigation guard. It can appear more than once, but only if the logical paths
  have no overlap, otherwise the hook will never be resolved or produce errors.
*/
router.beforeEach((to: Route, _from: Route, next: NavigationGuardNext<Vue>) => {
  // Unsubscribe any previous auth state change observer when moving to another
  // route. If the new route requires authentication, we'll subscribe again for
  // that route.
  if (authStateChangeUnsubscriber !== null) {
    authStateChangeUnsubscriber()
    authStateChangeUnsubscriber = null
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    authStateChangeUnsubscriber = fb.firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next()
      } else {
        next({ name: 'login', query: { redirect: to.fullPath } })
      }
    })
  } else {
    next()
  }
})

export default router
